<template>
    <div class="products" data-aos="fade-right" :style="{
        position:top>height?'fixed':'absolute',
        top:top>height?'100px':'65px',
    }">
        <el-menu
          :defaultActive="defaultActive"
          class="el-menu-vertical-demo "
          @select="handleSelect"
          >
          <el-menu-item v-for="item,index in productsList" :index="item.src"
                        :disabled="index===0
                        || index === 2
                        || index === 3
                        || index === 4
                        || index === 5
                        || index === 6
                        || index === 7
                        || index === 8
                        "
          >
              <span v-if="index!==0" v-html="item.title"></span>
              <div v-else>
                  <span v-html="item.title"></span>
                  <img :src="item.src" alt="" height="36px">
              </div>
          </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    data(){
      return {
        productsList:[
            {
              title:'EH-ODS<br>组学数据整合平台解决方案',
              src:require('@/assets/tyLogo.png'),
            },
            {
              title:'BioOmics组学数据发布管理平台',
              src:'/database/bioOmics'
            },
            {
              title:'PrivaCore基础隐私计算平台',
              src:'/database/privaCore'
            },
            {
              title:'BioAnalyst<br>生物信息集成分析平台',
              src:'/database/bioAnalyst'
            },
            {
              title:'SciAnalyst科研分析平台',
              src:'/database/sciAnalyst'
            },
            {
              title:'OmicsVison组学数据<br>数字孪生大屏可视化系统',
              src:'/database/omicsVison'
            },
            {
              title:'高性能计算存储平台',
              src:'/database/odsStorage'
            },
            {
              title:'组学数据整合平台相关服务',
              src:'/database/odsService'
            },
            {
              title:'组学数据整合平台资料下载',
              src:'/database/odsDownload'
            }
        ],
        defaultActive:'/database/bioOmics',
        top:0,
        height:window.innerHeight + 30
      }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll, true)
        this.defaultActive = this.$route.path
    },
    methods:{
        handleScroll(){
          let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
          this.top = top
        },
        handleSelect(src){
            this.$emit('menuSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
.products{
    position: absolute;
    left: 10px;
    top: 20px;
    /*bottom: 42px;*/
    z-index: 999999;
    visibility: visible!important;
    .el-menu-vertical-demo{
        background: none;
        border-right: none;
        .el-menu-item{
            width: 320px;
            height: 60px;
            box-sizing: border-box;
            padding: 0!important;
            line-height: 60px;
            text-align: left;
            font-size: 16px;
            margin-bottom: 2px;
            background: #ededed;
            letter-spacing: 3px;
            &>span{
                display: flex;
                align-items: center;
                padding: 0px 0 0px 20px;
            }
            &:hover{
                background: #006efd;
                color: #fff;
                span{
                    color: #fff;
                }
            }
        }
        .el-menu-item:nth-child(4),.el-menu-item:nth-child(6){
           span{
               line-height: 20px;
               padding: 10px 0 10px 20px;
            }
        }
        .el-menu-item:nth-child(1){
            cursor: auto;
            background: #ffe5e6!important;
            opacity: 1;
            &:hover{
                span{
                    color: #333;
                }
            }
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                line-height: 25px;
                height: 100%;
                padding: 0 20px;
                span{
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .is-active{
            background: #ed1c25;
            border-left: 5px solid #a50006;
            span{
                color: #fff;
            }
        }
    }
}

</style>
